import type { AppColumn, AppScalarValue } from './AppTable.types';

export interface AppDraftState<TRow> {
    rowId: string | number;
    original: TRow;
    draft: TRow;
}

export interface AppSavedRow<TRow> {
    source: TRow;
    value: TRow;
}

export function appEditRowKey(rowId: string | number): string {
    return `${typeof rowId}:${String(rowId)}`;
}

/** Return an immutable edited row, preferring a column's domain-specific setter. */
export function setAppColumnValue<TRow extends object>(
    column: AppColumn<TRow>,
    row: TRow,
    value: AppScalarValue,
): TRow {
    if (column.setValue) {
        return column.setValue(row, value);
    }

    const updated = Object.assign(Object.create(Object.getPrototypeOf(row)) as object, row);

    return Object.assign(updated, {
        [column.id]: value,
    }) as TRow;
}
